export class Controller {

    /** @ngInject */
    constructor(UsersResource) {
        this.UsersResource = UsersResource;
    }

    $onInit() {
    }

    deactivate() {
        this.isSaving = true;
        this.UsersResource
            .deactivateSmsUsageForCompanyUser(this.resolve.companyId, this.resolve.companyUserId)
            .then(() => this.close())
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/details/deactivate-sms/deactivate-sms.controller.js